module.exports = __webpack_public_path__ + "img/AnnouncementOutlined.bfc0cce0.svg";